var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("An error occured.")]),_c('br'),_c('b',[_vm._v(_vm._s(_vm.lastError.message))]),_c('br'),_vm._v(" "+_vm._s(_vm.lastError.stack)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }